import { action } from "typesafe-actions";
import { Permission, PermissionActionTypes } from "./types";

export const fetchRequest = () => action(PermissionActionTypes.FETCH);

export const fetchSuccess = (data: Permission) =>
  action(PermissionActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(PermissionActionTypes.FETCH_ERROR, error);
